import { render, staticRenderFns } from "./ListRasgadinhas.vue?vue&type=template&id=cd31a4d4&"
import script from "./ListRasgadinhas.vue?vue&type=script&lang=js&"
export * from "./ListRasgadinhas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports